/**
 * @file 申请试用页面
 * @author wangzhuang
 */

import {GET_USER_APPLY_DATA, GET_CMSAPI_USERAPPLY} from '../actions/ActionTypes';

export function userApplyData(state = {}, action) {
    switch (action.type) {
        case GET_USER_APPLY_DATA:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}

export function cmsapiUserapply(state = {}, action) {
    switch (action.type) {
        case GET_CMSAPI_USERAPPLY:
            state = action.data;
            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/apply.js